<template>

<div class="container-body-flex">
    <linkmenuleft ></linkmenuleft>
    <containerDocu/>
</div>

</template>


<script>
import Linkmenuleft from './MenuLeft'
import ContainerDocu from './ContainerDocu'
export default {
    components:{Linkmenuleft,ContainerDocu},

 data(){
        return{   
        }
    }
};
</script>

<style scoped>
.container-body-flex{
    display: flex;
    margin: 0 auto;
    width: 96%;
    max-width: 1280px;
}

</style>
